import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=5ec2f60a&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec2f60a')) {
      api.createRecord('5ec2f60a', component.options)
    } else {
      api.reload('5ec2f60a', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=5ec2f60a&", function () {
      api.rerender('5ec2f60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/menu.vue"
export default component.exports